<header class="header header--{{ theme() }} pt-topbar header-card-slider" #headerEl>
  <div class="container header__content position-relative z-2">
    @if (title() || header().title; as title) {
      <h1 class="h1 text-max-width-sm text-center mx-auto">
        {{ title }}
      </h1>
    }
    @if (text()) {
      <small class="fs-body-md fw-normal d-inline-block w-100 mb-2 text-center mx-auto" [innerHTML]="text()"></small>
    }

    <ng-content></ng-content>
  </div>

  <!--@if (header().events; as events) {
    <ul class="slide-list" [style.--list-count]="header().events?.length || 0" id="scroll-trigger-start">
      @for (event of events; track event.id) {
        <li class="slide-list__item" data-speed="clamp(0.5)" (mouseenter)="activeItem = $index; lastActiveItem = $index">

          <app-event-card-inverted [class.is--active]="$index === activeItem" [event]="event"></app-event-card-inverted>
        </li>
      }
    </ul>
  }-->

  @if ((slides().length || 0) > 0) {
    <swiper-container
      class="slider-list"
      init="false"
      #swiper
      id="scroll-trigger-start"
      (mouseenter)="paused = true"
      (mouseleave)="paused = false"
      [style.--list-count]="slides().length || 0"
    >
      @for (event of slides(); track $index) {
        <swiper-slide
          class="slider-list__slide"
          [class.is--odd]="$index % 2"
          (mouseenter)="activeItem = $index; lastActiveItem = $index"
          [class.is--active]="$index === activeItem"
          [class.slider--active]="$index === swiperIndex$()"
        >
          <app-event-card-inverted [event]="event.event" [hideImage]="event.hideImage"></app-event-card-inverted>
        </swiper-slide>
      }
    </swiper-container>
  }

  <div id="scroll-trigger-end"></div>
</header>
